
export const toggleLanguage = () => {
    return {
        type: "TOGGLE_LANGUAGE",
    }
}

export const setLanguage = (lang) => {
    return {
        type: "SET_LANGUAGE",
        language: lang,
    }
}
